// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ContactSchema from './contact-schema';
import DeliveryContactSchema from './delivery-contact-schema';
import SubscriptionArticleSchema from './subscription-article-schema';

const schema = {
  $id: '/subscription-contract-schema',
  type: 'object',
  required: [],
  properties: {
    subscriptionType: {
      enum: [
        1,
        2,
      ],
    },
    subscriptionStartDate: {
      type: 'string',
      format: 'date-time',
    },
    billingContact: {
      ...ContactSchema,
    },
    deliveryContact: {
      ...DeliveryContactSchema,
    },
    subscriptionArticle: {
      ...SubscriptionArticleSchema,
    },
    canBeCancelled: {
      type: 'boolean',
    },
    hasCombiSubscription: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
